import { render, staticRenderFns } from "./disabling-datavant-tokenization-modal.vue?vue&type=template&id=d96a4bce&"
import script from "./disabling-datavant-tokenization-modal.vue?vue&type=script&lang=js&"
export * from "./disabling-datavant-tokenization-modal.vue?vue&type=script&lang=js&"
import style0 from "./disabling-datavant-tokenization-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "disabling-datavant-tokenization-modal.vue"
export default component.exports